var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8787 35.1213L33.1213 35.8787C31.9497 37.0503 30.0503 37.0503 28.8787 35.8787L8 15L13 10L33.8787 30.8787C35.0503 32.0503 35.0503 33.9497 33.8787 35.1213Z",
    fill: "#5050D8",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 29C6.33333 27.6667 7.66667 26.3333 9 21C10.3333 26.3333 11.6667 27.6667 17 29C11.6667 30.3333 10.3333 31.6667 9 37C7.66667 31.6667 6.33333 30.3333 1 29Z",
    fill: "#4040D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7C20.6667 5.83333 21.8333 4.66667 23 0C24.1667 4.66667 25.3333 5.83333 30 7C25.3333 8.16667 24.1667 9.33333 23 14C21.8333 9.33333 20.6667 8.16667 16 7Z",
    fill: "#4040D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15C31.3333 14.1667 32.1667 13.3333 33 10C33.8333 13.3333 34.6667 14.1667 38 15C34.6667 15.8333 33.8333 16.6667 33 20C32.1667 16.6667 31.3333 15.8333 28 15Z",
    fill: "#4040D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41421 7.58579L5.58579 5.41421C6.36684 4.63317 7.63317 4.63317 8.41421 5.41421L13 10L8 15L3.41421 10.4142C2.63316 9.63316 2.63316 8.36684 3.41421 7.58579Z",
    fill: "#4040D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.c5973b9b5cbe07a68b02d59ff8a7ed75.svg";
export { ForwardRef as ReactComponent };